import { create } from "zustand";
import { Role, Screen, RolePermission, UserPermission, RoleWithStats, EffectivePermissions } from "../../models/DB";

interface RoleManagementStore {
    // State
    roles: RoleWithStats[];
    screens: Screen[];
    selectedRole: Role | null;
    rolePermissions: RolePermission[];
    userPermissions: UserPermission[];
    effectivePermissions: EffectivePermissions | null;
    isLoading: boolean;
    error: string | null;

    // Synchronous Actions 
    updateRoles: (roles: RoleWithStats[]) => void;
    updateScreens: (screens: Screen[]) => void;
    updateUserPermissions: (permissions: UserPermission[], effectivePermissions: EffectivePermissions) => void;
    updateRolePermissions: (permissions: RolePermission[]) => void;
    addRole: (role: RoleWithStats) => void;
    updateRole: (roleId: string, updates: Partial<RoleWithStats>) => void;
    removeRole: (roleId: string) => void;
    selectRole: (role: Role | null) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: string | null) => void;
    clearError: () => void;
}

export const roleManagementStore = create<RoleManagementStore>((set, get) => ({
    // Initial State
    roles: [],
    screens: [],
    selectedRole: null,
    rolePermissions: [],
    userPermissions: [],
    effectivePermissions: null,
    isLoading: false,
    error: null,

    // Synchronous Actions
    updateRoles: (roles) => set({ roles }),
    
    updateScreens: (screens) => set({ screens }),
    
    updateUserPermissions: (permissions, effectivePermissions) => set({ 
        userPermissions: permissions,
        effectivePermissions 
    }),
    
    updateRolePermissions: (permissions) => set({ rolePermissions: permissions }),
    
    addRole: (role) => {
        const { roles } = get();
        set({ roles: [...roles, role] });
    },
    
    updateRole: (roleId, updates) => {
        const { roles } = get();
        const updatedRoles = roles.map(role => 
            role.roleId === roleId ? { ...role, ...updates } : role
        );
        set({ roles: updatedRoles });
    },
    
    removeRole: (roleId) => {
        const { roles } = get();
        const filteredRoles = roles.filter(role => role.roleId !== roleId);
        set({ roles: filteredRoles });
    },
    
    selectRole: (role) => set({ selectedRole: role }),
    
    setLoading: (loading) => set({ isLoading: loading }),
    
    setError: (error) => set({ error }),
    
    clearError: () => set({ error: null })
})); 